import * as React from 'react';

interface ILoading {
  isLoading: boolean;
}

export default ({ isLoading }: ILoading) => {
  if (!isLoading) { return null; }
  return (
    <div className="resort-search__loading">
      <div className="resort-search__loading-icon" />
    </div>
  );
}
